import React from 'react';
import { Flex, Box, Text } from 'rebass/styled-components';
import PropTypes from 'prop-types';
import { TableRow } from '../agGrid/components/tableRow';

export const CompanyRowRenderer = ({ data, ...props }) => {
  if (!data.original) {
    return '';
  }

  if (data.original.id === 'load-more' || props.value === 'exclude' || data.isActiveSync || data.original.noContacts) {
    return '';
  }

  return props.value ? (
    <TableRow {...props}>
      <Box display="grid" height="100%" width="100%">
        <Flex p="8px" alignItems="flex-start">
          <Text
            fontSize="14px"
            sx={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {props.value}
          </Text>
        </Flex>
      </Box>
    </TableRow>
  ) : (
    <Flex sx={{ padding: '8px' }}>
      <Text fontSize="14px" fontStyle="italic" color="neutral.500">
        None
      </Text>
    </Flex>
  );
};

CompanyRowRenderer.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.array, PropTypes.bool, PropTypes.object]),
  data: PropTypes.object,
};

CompanyRowRenderer.defaultProps = {
  value: '',
  data: {},
};
